import { createFileRoute, redirect } from '@tanstack/react-router'

import { isOidcEnabled } from '@/lib/auth/oidc-bootstrap'
import { ResetPasswordForm } from '@/modules/login/components/reset-password-form'

export const Route = createFileRoute('/reset-password/$token')({
  beforeLoad: (): void => {
    // Keycloak owns credentials after the cutover: a stale reset email must not set a password
    // nobody can use, so this collapses into the /login shim.
    if (isOidcEnabled()) {
      throw redirect({'to': '/login'})
    }
  },

  loader: async ({params}) => {
    const {token} = params

    return {token}
  },
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <div className="flex min-h-svh w-full items-center justify-center p-6 md:p-10 bg-[#022D4F]">
      <ResetPasswordForm />
    </div>
  )
}
